<template>
  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 32 33">
    <path d="M13.5,22.4v-11.4l7.9,5.7-7.9,5.7Z" />
  </svg>
</template>
